import React from 'react';
import { createPortal } from 'react-dom';
import { DragOverlay, useDndContext } from '@dnd-kit/core';
import { useSelector } from 'react-redux';
import PlayerCard from './GameFields 3.0/components/PlayerCard';
import { getTeamStrategy, getTeamKit } from '../../../../../redux/selector/Team';
import { ratingRangeStatus } from '../../../../../service/constants';

// Keep the overlay mounted and outside transformed pitch slots and table layout.
export default function StrategyDragOverlay() {
  const { active } = useDndContext();
  const strategy = useSelector(getTeamStrategy);
  const kit = useSelector(getTeamKit);
  const id = active ? String(active.id).split(' ')[0] : null;
  const player = [...(strategy.majorStaff || []), ...(strategy.allTeam || []), ...(strategy.notMajorStaff || [])].find(p=>String(p._id)===id);
  return createPortal(<DragOverlay className="strategy-drag-preview" adjustScale={false} dropAnimation={null} zIndex={10000} style={{pointerEvents:'none'}}>
    {player ? <PlayerCard
      _id={player._id} firstName={player.first_name} lastName={player.last_name}
      playerPos={player.current_position || player.fav_position} ratingRange={ratingRangeStatus[player.rating_range]}
      potentialRange={ratingRangeStatus[player.potential_range]} formRange={player.form_range} teamKit={kit}
    /> : null}
  </DragOverlay>, document.body);
}
